import { SubmissionError } from 'redux-form';
import fetch from '../../core/fetch';

import { getListingDataStep3 } from '../../actions/getListingDataStep3';
import { manageListingSteps } from '../../actions/manageListingSteps';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';
import history from '../../core/history';
import messages from '../../locale/messages';
import { updateListingStep3 as query } from '../../lib/graphql';
import { userRestriction } from '../../helpers/DemoRestriction/demoRestriction';
import showToaster from '../../helpers/showToaster';

async function updateStep3(values, dispatch) {

  const isRestrict = await dispatch(userRestriction({ restrictType: 'listing', restrictValue: values?.id }));
  if (isRestrict) {
    showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
    return;
  }

  let weeklyDiscount = Number(values?.weeklyDiscount) || 0;
  let monthlyDiscount = Number(values?.monthlyDiscount) || 0;
  let cleaningPrice = parseFloat(values?.cleaningPrice) || 0;
  let tax = parseFloat(values?.tax) || 0;

  let id, houseRules, additionalRules, bookingNoticeTime, checkInStart, checkInEnd, maxDaysNotice, minNight, maxNight, basePrice, weekendPrice, minStayWeekend, currency, blockedDates, bookingType, cancellationPolicy, extraGuestThreshold, extraGuestFee, cautionDeposit, customDiscounts;

  id = Number(values?.id);
  houseRules = values?.houseRules;
  additionalRules = values?.additionalRules;
  bookingNoticeTime = String(values?.bookingNoticeTime);
  checkInStart = values?.checkInStart;
  checkInEnd = values?.checkInEnd;
  maxDaysNotice = values?.maxDaysNotice;
  minNight = values?.minNight;
  maxNight = values?.maxNight;
  basePrice = parseFloat(values?.basePrice);
  weekendPrice = values?.weekendPrice ? parseFloat(values?.weekendPrice) : null;
  minStayWeekend = values?.minStayWeekend || false;
  currency = values?.currency;
  blockedDates = values?.blockedDates;
  bookingType = values?.bookingType;
  cancellationPolicy = values?.cancellationPolicy ? Number(values?.cancellationPolicy) : 1;
  extraGuestThreshold = values?.extraGuestThreshold ? Number(values?.extraGuestThreshold) : null;
  extraGuestFee = values?.extraGuestFee ? parseFloat(values?.extraGuestFee) : null;
  cautionDeposit = values?.cautionDeposit ? parseFloat(values?.cautionDeposit) : null;
  customDiscounts = values?.customDiscounts || null;

  let variables = Object.assign({}, {
    weeklyDiscount, monthlyDiscount, cleaningPrice, tax, id, houseRules, additionalRules, bookingNoticeTime,
    checkInStart, checkInEnd, maxDaysNotice, minNight, maxNight, basePrice, weekendPrice, minStayWeekend, currency,
    blockedDates, bookingType, cancellationPolicy, extraGuestThreshold, extraGuestFee, cautionDeposit, customDiscounts
  });

  dispatch(setLoaderStart('updateListing'));

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables
    }),
    credentials: 'include'
  });

  const { data } = await resp.json();

  if (data?.updateListingStep3 != undefined) {
    if (data?.updateListingStep3.status == "success") {
      await dispatch(manageListingSteps(values.id, 3));
      history.push('/become-a-host/' + values.id + '/home');
      await dispatch(getListingDataStep3(values.id));
      await dispatch(setLoaderComplete('updateListing'));
    } else if (data?.updateListingStep3?.status == "notLoggedIn") {
      dispatch(setLoaderComplete('updateListing'));
      throw new SubmissionError({ _error: messages.notLoggedIn });
    } else {
      dispatch(setLoaderComplete('updateListing'));
      throw new SubmissionError({ _error: messages.somethingWentWrong });
    }
  } else {
    dispatch(setLoaderComplete('updateListing'));
    throw new SubmissionError({ _error: messages.somethingWentWrong });
  }

}

export default updateStep3;
